import Global from '@/global'
import i18n from '@/i18n'
import rtc from '@/rtccomm'
import { message } from 'ant-design-vue'

export const MICROPHONEAUTHSTATES = {
  ALLOW: 0, // Permission allow 允许
  NONE: 1, // Permission none 默认
  DENIED: 2, // Permission denied 拒绝
  DISMISSED: 3 // Permission dismissed 忽略
}

/*
  授权中加锁
  不加锁连续调用函数，导致第三次忽略&拒绝，连续弹出三次提示
 */
let isShowMicroPhoneAlart = false

/*
  是否需要提示

  列举使用位置
  1. 进入协作列表不提示
  2. 进入协作不提示 && 刷新协作不提示
  3. 点击麦克风全程提示
*/
export function microPhoneAuthCheck(isToast){
  // 麦克风允许
  if (Global.MICROPHONEAUTHSTATE === MICROPHONEAUTHSTATES.ALLOW){
    return true
  }
  // 麦克风不允许
  if (Global.MICROPHONEAUTHSTATE === MICROPHONEAUTHSTATES.DENIED) {
    isToast && toast()
    return false
  }
  // 当前正在授权
  if (isShowMicroPhoneAlart){
    isToast && message.warn(i18n.tc('warn.SelectAndContinue'))
    return false
  }
  // 开始授权并加锁
  isShowMicroPhoneAlart = true
  rtc.getMicrophones().then(_ => {
    // 初次授权成功
    isShowMicroPhoneAlart = false
    Global.MICROPHONEAUTHSTATE = MICROPHONEAUTHSTATES.ALLOW
  }).catch(e => {
    isShowMicroPhoneAlart = false
    if (e.message.includes('dismissed')) {
      // 首次,二次,忽略授权
      Global.MICROPHONEAUTHSTATE = MICROPHONEAUTHSTATES.DISMISSED
      isToast && toast()
    } else if (e.message.includes('denied')){
      // 二次授权拒绝,三次忽略授权
      Global.MICROPHONEAUTHSTATE = MICROPHONEAUTHSTATES.DENIED
      isToast && toast()
    }
  })
  // 授权拒绝或者允许不给继续操作，
  // 因：授权弹窗不确定在何时被点击！！！
  return false
}

function toast(){
  message.warn(i18n.tc('warn.GrantMicrophoneAuthWarning'))
}
